import { render, staticRenderFns } from "./DownloadsDialog.vue?vue&type=template&id=4f3a04cc&"
import script from "./DownloadsDialog.vue?vue&type=script&lang=js&"
export * from "./DownloadsDialog.vue?vue&type=script&lang=js&"
import style0 from "./DownloadsDialog.vue?vue&type=style&index=0&id=4f3a04cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports